import React from 'react';
import styled from 'styled-components';

const Header = styled.div`
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 16px;
  min-height: 44px;
`;
const Identity = styled.div`display: flex; align-items: center; gap: 10px; min-width: 0;`;
const Title = styled.h1`margin: 0; color: ${({ theme }) => theme.color.text_color_100}; font-size: 20px; font-weight: 600; line-height: 28px; letter-spacing: -0.5px;`;
const Count = styled.span`color: ${({ theme }) => theme.color.text_color_300}; background: ${({ theme }) => theme.color.primary_50}; border: 1px solid ${({ theme }) => theme.color.primary_300}; border-radius: 5px; padding: 1px 6px; font-size: 12px; font-variant-numeric: tabular-nums;`;
const Description = styled.p`margin-top: 5px; color: ${({ theme }) => theme.color.text_color_300}; font-size: 12px;`;
const Actions = styled.div`display: flex; align-items: center; flex-wrap: wrap; gap: 8px;`;

export default function PageHeader({ title, count, description, actions }: { title: string; count?: number; description?: string; actions?: React.ReactNode }) {
  return <Header><div><Identity><Title>{title}</Title>{count !== undefined && <Count aria-label={`총 ${count}건`}>{count.toLocaleString()}</Count>}</Identity>{description && <Description>{description}</Description>}</div>{actions && <Actions>{actions}</Actions>}</Header>;
}
